import { useActions, useApiActions } from "state/hooks";
import { handleBrowserUpload } from "state/actions/upload";

import {
    createDirectory,
    deleteDirectory,
    importMedia,
    saveMedia,
    syncMedia,
    selectMedia,
    deleteMedia,
    selectTarget,
    cancelSelectTarget,
    assignTarget,
    saveMediaCallback,
} from "state/actions/media";

export function useMediaActions() {
    const apiActions = useApiActions({
        onUploadMedia: handleBrowserUpload,
        onDeleteMedia: deleteMedia,
        onCreateDirectory: createDirectory,
        onDeleteDirectory: deleteDirectory,
        onImportMedia: importMedia,
        onSyncMedia: syncMedia,
        onSaveMedia: saveMediaCallback,
    });
    const mediaActions = useActions({
        onSelect: selectMedia,
        onSelectTarget: selectTarget,
        onCancelSelectTarget: cancelSelectTarget,
        onAssignTarget: assignTarget,
    });

    return { ...apiActions, ...mediaActions };
}
